import { Link } from 'react-router-dom';

export default function Hero() {
  const scrollToDiagnostic = () => {
    const element = document.getElementById('diagnostic-section');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-primary-500 via-primary-600 to-primary-700">
      {/* Background Pattern */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/18cdfe6156f40602d2771d7399d064af.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.3
        }}
      />
      
      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-left space-y-8">
            <div className="inline-block">
              <span className="px-4 py-2 bg-coral-500/20 text-coral-500 rounded-full text-sm font-semibold border border-coral-500/30">
                Programa de 10-12 meses
              </span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-bold text-white leading-tight">
              Transforme seu MEI em uma
              <span className="text-coral-500"> Máquina de Eficiência</span>
            </h1>
            
            <p className="text-xl text-gray-200 leading-relaxed">
              Programa completo de melhoria de processos para MEI e pequenas empresas. 
              <strong className="text-white"> Resultados reais desde o 1º mês</strong> com ganhos contínuos 
              de produtividade, organização e eficiência ao longo de 10-12 meses.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={scrollToDiagnostic}
                className="px-8 py-4 bg-coral-500 text-white rounded-lg font-semibold text-lg hover:bg-coral-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Fazer Diagnóstico Gratuito
              </button>
              <button
                onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                className="px-8 py-4 bg-white text-primary-600 border-2 border-white rounded-lg font-semibold text-lg hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer"
              >
                Agendar Conversa
              </button>
            </div>
            
            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-white/20">
              <div>
                <div className="text-3xl font-bold text-coral-500">10-12</div>
                <div className="text-sm text-gray-300">Meses de programa</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-coral-500">+40%</div>
                <div className="text-sm text-gray-300">Ganho médio de produtividade</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-coral-500">100%</div>
                <div className="text-sm text-gray-300">Suporte personalizado</div>
              </div>
            </div>
          </div>
          
          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20business%20consultant%20working%20with%20small%20business%20owner%20reviewing%20process%20improvement%20charts%20and%20digital%20dashboards%20on%20modern%20laptop%2C%20collaborative%20meeting%20atmosphere%2C%20bright%20office%20environment%20with%20organized%20workspace%2C%20realistic%20photography%20showing%20productivity%20tools%20and%20business%20growth%20metrics%2C%20coral%20and%20navy%20blue%20professional%20color%20scheme&width=800&height=900&seq=hero-main-002&orientation=portrait"
                alt="Consultoria LBAs Essentials"
                className="w-full h-full object-cover object-top"
              />
            </div>
            
            {/* Floating Card */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-6 max-w-xs">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-coral-500/10 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-2xl text-coral-500"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900">Resultados Garantidos</div>
                  <div className="text-sm text-gray-600">Metodologia validada</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
